import React, { Component, Fragment } from 'react';
import { connect } from 'dva';
import router from 'umi/router';
import Header from 'components/Header';
import Loading from 'components/Loading';
import Footer from 'components/Footer';
import SelectCondition from 'components/SelectCondition';
import styles from './index.less';
import { isEmpty } from 'utils/index';
import { getAgentId } from '@/utils/getValue';
import { cipLogin } from '../../../services';
import cipDefault from 'images/cipDefault.png';
import airportDefault from 'images/airportDefault.png';
import trainDefault from 'images/trainDefault.png';

// 移动专用特殊休息室页面 移动项目未下之前 不要删！！！ 20230223

const languageMap = {
  'zh-cn': {
    boardingGate: '登机口',
  },
  en: {
    boardingGate: 'boardingGate',
  },
};

@connect(({ airportMotion, cip, loading }) => ({
  loungeList: airportMotion.loungeList,
  cipList: cip.cipList,
  allData: airportMotion.allData,
  loading: loading.effects['airportMotion/queryNetworkDetail'],
}))
class Airport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeState: {},
    };
  }
  componentDidMount() {
    const { sid, language, type, listType } = this.props.location.query;
    const that = this;
    window.parent && window.parent.postMessage({ iframeType: 'list' }, '*');
    document.body.style = 'background-color: #fff';
    if (listType === 'cip') {
      this.props.dispatch({
        type: 'cip/getCipNetworkDetail',
        payload: {
          ...this.props.location.query,
          callback: () => {
            // if (Number(type) === 2) {
            //   const hasLounge = that.props.loungeList.some((item) => {
            //     return String(item.loungeType) === '1';
            //   });
            //   that.setState({
            //     activeState: { loungeType: hasLounge ? '休息室' : '餐饮体验厅' },
            //   });
            // }
          },
        },
      });
      return;
    }
    this.props.dispatch({
      type: 'airportMotion/queryNetworkDetail',
      payload: {
        ...this.props.location.query,
        sid,
        language,
        agentId: getAgentId(),
        callback: () => {
          if (Number(type) === 2) {
            let loungeNum = 0,
              foodNum = 0;
            that.props.loungeList.forEach((item) => {
              String(item.loungeType) === '1' && loungeNum++;
              String(item.loungeType) === '4' && foodNum++;
            });
            that.setState({
              activeState: { loungeType: loungeNum >= foodNum ? '休息室' : '餐饮体验厅' },
            });
          }
        },
      },
    });
  }

  toLounge(code) {
    const { language, listType } = this.props.location.query;
    if (listType === 'cip') {
      router.push({
        pathname: '/lounge/motion',
        query: { listType, code, returnUrl: encodeURIComponent(window.location.href) },
      });
      return;
    }
    router.push({
      pathname: '/lounge/motion',
      query: {
        code,
        language,
        returnUrl: encodeURIComponent(window.location.href),
      },
    });
  }

  onConfirm = (activeState) => {
    console.log(activeState, 'activeStateactiveState');
    this.setState({
      activeState: { ...activeState },
    });
  };

  selectLoungeType = (type) => {
    this.setState({
      activeState: { loungeType: type },
    });
  };
  render() {
    let condition = [];
    const { loungeList = [], cipList = [], loading, allData = {} } = this.props;
    const { inspections, terminals, types } = allData;
    const { activeState = {} } = this.state;
    const { name, type, listType } = this.props.location.query; // type 1机场，2 高铁
    let imgDefault = trainDefault;
    if (Number(type) === 1) {
      terminals && condition.push({ key: 'terminal', label: '航站楼', value: terminals });
      types && condition.push({ key: 'type', label: '出发类型', value: types });
      inspections && condition.push({ key: 'inspection', label: '安检前后', value: inspections });
      let hasFood = false,
        hasLounge = false,
        loungeValue = ['休息室', '餐饮体验厅'];

      loungeList.forEach((item) => {
        if (String(item.loungeType) === '4') {
          hasFood = true;
        }
        if (String(item.loungeType) === '1') {
          hasLounge = true;
        }
      });
      !hasFood && (loungeValue = ['休息室']);
      !hasLounge && (loungeValue = ['餐饮体验厅']);
      condition.push({ key: 'loungeType', label: '休息室类型', value: loungeValue });

      imgDefault = airportDefault;
    }
    console.log(cipList, 'cipList');
    if (listType === 'cip') {
      const terminalValue = new Set([]);
      const typeValue = new Set([]);
      cipList.forEach((item) => {
        terminalValue.add(item.terminal);
        typeValue.add(item.type);
      });
      condition.push({ key: 'terminal', label: '航站楼', value: [...terminalValue] });
      condition.push({ key: 'type', label: '出发类型', value: [...typeValue] });

      imgDefault = cipDefault;
    }
    //condition.push({ key: 'loungeType', label: '休息室类型', value: ['休息室', '餐饮体验厅'] });
    const dataList = listType === 'cip' ? cipList : loungeList;
    const filterList = dataList.filter((item) => {
      return Object.keys(activeState).every((key) => {
        const isLoungeType = key === 'loungeType';
        if (activeState[key]) {
          if (isLoungeType) {
            const isLounge = activeState[key] === '休息室' && item.loungeType === '1';
            const isFood = activeState[key] === '餐饮体验厅' && item.loungeType === '4';
            return isLounge || isFood;
          }
          return activeState[key] === item[key];
        }
        return true;
      });
    });
    //const imgDefault = require(imgDefaultStr);
    return (
      <Fragment>
        <Loading loading={loading}>
          <div className={styles.content}>
            {Number(type) === 1 || String(listType) === 'cip' ? (
              <SelectCondition
                condition={condition}
                initActiveState={activeState}
                onConfirm={this.onConfirm}
              />
            ) : (
              <div style={{ padding: '0 0 0.2rem', background: '#fff' }}>
                <div className={styles.trainSelect}>
                  <div
                    className={`${styles.selectButton} ${
                      activeState['loungeType'] === '休息室' ? styles.active : ''
                    }`}
                    onClick={() => this.selectLoungeType('休息室')}
                  >
                    休息室
                  </div>
                  <div
                    className={`${styles.selectButton} ${
                      activeState['loungeType'] === '餐饮体验厅' ? styles.active : ''
                    }`}
                    onClick={() => this.selectLoungeType('餐饮体验厅')}
                  >
                    餐饮体验厅
                  </div>
                </div>
              </div>
            )}
            <div className={styles.selectBtn}></div>
            {filterList.length > 0 ? (
              filterList.map((item) => {
                const imgUrl = item.products && item.products.imgUrl ? item.products.imgUrl : '';
                let url = imgUrl.split('?') || [];
                url = url[0]
                  ? `${url[0]}?x-oss-process=image/auto-orient,1/resize,m_fill,w_400,h_360/quality,q_90`
                  : imgDefault;

                return (
                  <div
                    className={styles.block}
                    onClick={() => this.toLounge(item.code)}
                    key={item.id}
                  >
                    <div className={styles.picWrap}>
                      <img className={styles.pic} src={url} alt="" />
                    </div>

                    <div className={styles.info}>
                      <div className={styles.airport}>{item.name}</div>
                      <div className={styles.terminal} style={{ marginTop: '0.15rem' }}>
                        {item.type}
                        {item.terminal} {' ' + (item.businessHours || item.businesshours)}
                      </div>
                      <div className={styles.terminal} style={{ margin: '0.2rem 0' }}>
                        <div className={styles.detail}>
                          {(item.inspection || '') + ' ' + (item.locationGuide || item.location)}
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : (
              <div className={styles.emptyPage}>
                <img className={styles.empty} src={require('images/airportEmpty.png')} alt="" />
                <div>暂无网点可供使用</div>
              </div>
            )}
            <Footer />
          </div>
        </Loading>
      </Fragment>
    );
  }
}

export default Airport;
